module.exports = __webpack_public_path__ + "media/images/unspecified_image-89591c58bc351e64bd560d5de53635e9.jpg";